import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import TopNav from "./TopNav";
import CartComponent from "./CartComponent";

function Cart({ cart, setCart }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [selections, setSelections] = useState({});
  const [shippingCostInfo, setShippingCostInfo] = useState(null);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchShippingCostInfo = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/shippingcostInfo`);
        setShippingCostInfo(res.data);
      } catch (err) {
        console.error("Failed to load shipping cost info", err);
        setError("Could not load shipping information.");
      }
    };

    const fetchProducts = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/products`);
        setProducts(res.data);
      } catch (err) {
        console.error("Error occurred loading products", err);
        setError("Could not load products");
      }
      finally {
        setLoading(false);
      }
    };

    fetchShippingCostInfo();
    fetchProducts();

  }, []);


  if (loading) return <p>Loading...</p>;

  if (!shippingCostInfo) {
    return <div>Loading shipping info...</div>;
  }

  const handleCheckout = async () => {

    try {
      navigate(`/checkout`);
    } catch (err) {
      console.error(err);
      setError("Checkout failed. Please try again.");
    }
  };

  if (cart.length === 0) {
    return (
      <div>
        <TopNav cart={cart} />
        <div className="pane dark_pane">
          <div className="left_right_container">
            <div className="left">
              <h2>Your Cart</h2>
              <p>Your cart is empty.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const handleChange = (productId, size, field, value) => {
    setCart(prevCart => {
      return prevCart.map(item => {
        if (item.productId === productId && item.size === size) {
          return { ...item, [field]: value };
        }

        return item;
      });
    });
  };

  const removeFromCart = (productId, size) => {
    const updatedCart = cart.filter(item => !(item.productId === productId && item.size === size));
    setCart(updatedCart);
    const updatedSelections = { ...selections };
    delete updatedSelections[productId];
    setSelections(updatedSelections);
    localStorage.setItem("cart", JSON.stringify(updatedCart));
  };

  return (
    <div>
      <TopNav cart={cart} />
      <div className="pane dark_pane">
        <div className="container">
          <h2>Your Cart</h2>
          <CartComponent
            cart={cart}
            products={products}
            shippingCostInfo={shippingCostInfo}
            editable={true}
            handleChange={handleChange}
            removeFromCart={removeFromCart}
          />
          <div className="form-group">
            {error && <p style={{ color: "red" }}>{error}</p>}

            <button className="add" onClick={handleCheckout}>Submit Order</button>
          </div>
        </div>
      </div>
    </div>
  );
}


export default Cart;